import { createContext } from 'react';
import { AcquireTokenFunction, AuthStateProps } from '@konecorp/ui-library';

export type ErrorMessage = {
  message: string;
  error: unknown;
};

export interface ContextState {
  authState: AuthStateProps;
  isLoading: boolean;
  acquireToken?: AcquireTokenFunction;
  updateAuthState: (authState: AuthStateProps) => void;
  updateAcquireToken: (newFunction: () => AcquireTokenFunction) => void;
  updateIsLoading: (status: boolean) => void;
  showError: boolean;
  setShowError: (status: boolean) => void;
  message: string;
  setMessage: (message: string) => void;
  showSuccess: boolean;
  setShowSuccess: (status: boolean) => void;
}

export default createContext({} as ContextState);
